import { eventStatuses } from "../../../../utils/Constants";

export const EVENT_PAYMENT_STATES = {
  draft: "draft",
  pending: "pending",
  /** Published after the Super Admin accepted the publishing request. */
  approved: "approved",
};

export const PAYMENT_REQUEST_STATUSES = {
  pending: "pending",
  accepted: "accepted",
  rejected: "rejected",
  canceled: "canceled",
};

/** Saved with no payment submitted: every detail, crew size included, is still editable. */
export const isDraftEvent = (event) => event?.status === eventStatuses.draft;

/** Not published yet: a draft, or a publishing request waiting on the Super Admin. */
export const isUnpublishedEvent = (event) =>
  [eventStatuses.draft, eventStatuses.pendingPayment].includes(event?.status);

/**
 * Which payment state the Basic Information card shows: draft, pending, or approved once
 * an accepted request published the event (null for an event published without one).
 * `request` is the event's latest publishing request (`last_publish_payment_request`),
 * when there is one: the pending one, the cancelled / rejected one of a draft, or the
 * accepted one of a published event.
 */
export const getEventPaymentState = (event) => {
  const request = event?.last_publish_payment_request ?? null;
  if (event?.status === eventStatuses.pendingPayment) {
    return {
      state: EVENT_PAYMENT_STATES.pending,
      submittedAt: request?.created_at,
      request,
    };
  }
  if (event?.status === eventStatuses.draft) {
    return { state: EVENT_PAYMENT_STATES.draft, request };
  }
  if (request?.status === PAYMENT_REQUEST_STATUSES.accepted) {
    return { state: EVENT_PAYMENT_STATES.approved, request };
  }
  return null;
};
